export interface ActivityLog {
  action: string;
  customerId?: string;
  dateTime: string;
  jimboUser: string;
  url?: string;
  description: string;
}

export enum Actions {
  syncVoucher = 'sync-voucher',
  refund = 'refund',
  updateemail = 'updateemail',
  customerDetailsUpdate = 'customer-details-update',
  attributeValues = 'attribute-values',
  addresses = 'addresses',
  resetPassword = 'reset-password',
  emergencyEmailUpdate = 'emergency-email-update',
  terminateAccount = 'terminate-account',
  updateroles = 'updateroles',
  coupons = 'coupons',
}

export enum ControllerActions {
  orders = 'orders',
  customers = 'customers',
  users = 'users',
  talon = 'talon',
}
